export const appActionTypes = {
  SET_CLIENT_REQUEST: "SET_CLIENT_REQUEST",
  SET_CLIENT_SUCCESS: "SET_CLIENT_SUCCESS"
};
